var pagination = "pagination";
var next = "Next";
var previous = "Previous";
var pageOfPageCount = "{page} of {pageCount}";
var startToEndOutOfTotalResults = "{start}-{end} out of {totalCount, plural, =0 {0 results} one {1 result} other {{totalCount} results}}";
var enUS = {
	pagination: pagination,
	next: next,
	previous: previous,
	pageOfPageCount: pageOfPageCount,
	startToEndOutOfTotalResults: startToEndOutOfTotalResults
};

export { enUS as default, next, pageOfPageCount, pagination, previous, startToEndOutOfTotalResults };
